import React, { useState, useEffect } from "react";
import AddTimeModal from "../AddTimeModal";

const Header = ({extraFiltersState, setExtraFiltersState, setCurrentWeek}) => {
  const [showTaskModal, setShowTaskModal] = useState(false);

  const handleOpenTaskModal = () => setShowTaskModal(true);
  const handleCloseTaskModal = () => setShowTaskModal(false);

  return (
    <>
      <div className="z-1">
        <div className="d-flex justify-content-between align-items-center p-4">
          <h1 className="font-24 font-weight-s-bold m-0">
            Weekly Time Entry By User
          </h1>
          <button className="add-new-btn" variant="none" onClick={handleOpenTaskModal}>
            <img
              className="me-2 add-user-icon"
              src="/assets/images/add-icon.svg"
              alt="Add Time"
            />
            Add Time
          </button>
        </div>
      </div>
      <AddTimeModal show={showTaskModal} setCurrentWeek={setCurrentWeek} extraFiltersState={extraFiltersState} setExtraFiltersState={setExtraFiltersState} handleClose={handleCloseTaskModal} />
    </>
  );
};

export default Header;
